import { render, staticRenderFns } from "./EventsNotify.vue?vue&type=template&id=6fe4a107"
import script from "./EventsNotify.js?vue&type=script&lang=js&external"
export * from "./EventsNotify.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports